export const APPROVAL_RESPONSE_TYPE = 'APPROVAL';
export const AUTOMATIC_RESPONSE_TYPE = 'AUTOMATIC';
export const MANUAL_RESPONSE_TYPE = 'MANUAL';

export const TEMPLATE_GENERATION_TYPE = 'TEMPLATE';
export const AI_GENERATION_TYPE = 'AI';

export const DELAY_UNIT_DAYS = 'DAYS';
export const DELAY_UNIT_HOURS = 'HOURS';
export const DELAY_UNIT_MINUTES = 'MINUTES';

export const SETTINGS_DESCRIPTION =
  'Configure how you would like to handle responses to incoming reviews. Customize templates, AI settings, add incentives, and adjust notifications for each rating.';
